import React, { useEffect, useState } from "react";
import { SyncOutlined } from "@ant-design/icons";
// import Moment from "moment";
import Moment from "react-moment";
import { toast } from "react-toastify";
// import axios from "axios";
import { axiosInstance } from "../../config";
const DoughnutOCard = () => {
  const [pastries, setPastries] = useState([{}]);
  const [count, setCount] = useState(0);
  const [search, setSearch] = useState();

  useEffect(() => {
    try {
      const fetchCake = async () => {
        const orderdata = await axiosInstance.get("/api/mymy");
        setPastries(orderdata.data.alldoughnut);
        // setCupCake(orderdata.data.allcupcake);
        // setDoughnut(orderdata.data.alldoughnut);
      };
      fetchCake();
    } catch (err) {
      toast.error(err.response.data);
    }
  }, [count]);
  //delete
  const handleDelete = async (index) => {
    const answer = window.confirm(
      "Are you sure you want to delete?, Miriam i cannot retrieve any info after you delete lol.."
    );
    if (!answer) return;
    let allcakes = pastries;
    const removed = allcakes.splice(index, 1);
    // setPastries(allcakes);
    //   console.log("all", allcakes);
    const { data } = await axiosInstance.put(`api/mymy/deletedoughnut`, {
      id: removed[0]._id,
    });
    setCount(() => count + 1);
    console.log("order", data);
    // console.log("rmv", removed[0]._id);
  };

  //search
  const searchItems = (e) => {
    e.preventDefault();
    const results = pastries.filter((item) => {
      return Object.values(item)
        .join("")
        .toLowerCase()
        .includes(search.toLowerCase());
    });
    setPastries(results);
  };
  const refresh = (e) => {
    try {
      const fetchCake = async () => {
        const orderdata = await axiosInstance.get("/api/mymy");
        setPastries(orderdata.data.allcake);
        // setCupCake(orderdata.data.allcupcake);
        // setDoughnut(orderdata.data.alldoughnut);
      };
      fetchCake();
    } catch (err) {
      toast.error(err.response.data);
    }
  };
  console.log("object", pastries);
  return (
    <>
      <h3 className="coc-heading">Dougnut Orders</h3>
      <input
        className="search"
        name="Search"
        type="text"
        placeholder="Search"
        onChange={(e) => setSearch(e.target.value)}
      />
      <button onClick={searchItems}>Go</button>
      <button onClick={refresh}>Return</button>
      <div className="coc-main">
        {pastries ? (
          pastries.map((pastry, index) => (
            <div key={index} className="coc-card-main">
              <h1>
                <Moment>{pastry.updatedAt}</Moment>
              </h1>
              <div className="coc-card">
                <div className="coc-details">
                  <h1 className="coc-label">Name: </h1>
                  <h1 className="coc-value">{pastry.name}</h1>
                  {/* <h1>;</h1> */}
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Contact: </h1>
                  <h1 className="coc-value">{pastry.contact}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Quantity: </h1>
                  <h1 className="coc-value">{pastry.quantity}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Delivery Method: </h1>
                  <h1 className="coc-value">{pastry.delivery}</h1>
                </div>
                <div className="coc-details">
                  <h1 className="coc-label">Total: </h1>
                  <h1 className="coc-value">{pastry.price + " GHC"}</h1>
                </div>
              </div>
              <button onClick={() => handleDelete(index)}>Delete</button>
            </div>
          ))
        ) : (
          <SyncOutlined spin />
        )}
      </div>
    </>
  );
};

export default DoughnutOCard;
